export interface IAppointmentDetails {
  siteId: number;
  conversationId: number;
  routingUniqueId: string;
  callDetailRecordId: number;
  tourInformation: IAppointmentTourInfo;
}

export interface IAppointmentTourInfo {
  tourType: string;
  tourDate: string;
  tourTime: string;
  tourDateTimeUtterance: string;
}

export class AppointmentTourInfoModel implements IAppointmentTourInfo {
  tourType: string = '';
  tourDate: string = '';
  tourTime: string = '';
  tourDateTimeUtterance: string = '';

  constructor(data: IAppointmentTourInfo) {
    this.tourType = data.tourType ?? this.tourType;
    this.tourDate = data.tourDate ?? this.tourDate;
    this.tourTime = data.tourTime ?? this.tourTime;
    this.tourDateTimeUtterance = data.tourDateTimeUtterance ?? this.tourDateTimeUtterance;
  }
}

export class AppointmentDetailsModel implements IAppointmentDetails {
  siteId: number = 0;
  conversationId: number = 0;
  routingUniqueId: string = '';
  callDetailRecordId: number = 0;
  tourInformation: IAppointmentTourInfo = {} as IAppointmentTourInfo;

  constructor(data: IAppointmentDetails) {
    this.siteId = data.siteId ?? this.siteId;
    this.conversationId = data.conversationId ?? this.conversationId;
    this.routingUniqueId = data.routingUniqueId ?? this.routingUniqueId;
    this.callDetailRecordId = data.callDetailRecordId ?? this.callDetailRecordId;
    this.tourInformation = new AppointmentTourInfoModel(data.tourInformation ?? this.tourInformation);
  }
}
